// extracted by mini-css-extract-plugin
module.exports = {"welcomeBox":"style__welcomeBox__DDhEc","redirectBox":"style__redirectBox__trxVW","cvLink":"style__cvLink__qpXos"};